import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import DrawerPage from '../../components/app/DrawerPage';
import LabelDivider from '../../components/app/LabelDivider';
import { useRoute, useLocation } from 'wouter';
import UserForm from '../../components/users/UserForm';
import ax from '../../lib/api';
import UserPasswordForm from '../../components/users/UserPasswordForm';
import useAuthStore from '../../store/auth';
import ManagedUserForm from '../../components/users/ManagedUserForm';
import ProviderDocsForm from '../../components/providers/ProviderDocsForm';
import { roles } from '../../hooks/useRole';

const UserFormPage = () => {
  const [, params] = useRoute('/users/:id');
  const [isSelf] = useRoute('/users/self');
  const [user, setUser] = useState();
  const [, setLocation] = useLocation();
  const currentUser = useAuthStore((state) => state.user);

  const canManageUsers =
    currentUser?.group === roles.AGENCY_ADMIN &&
    user?.group === roles.AGENCY_SUPERVISOR;

  const userId = useMemo(() => {
    let id = parseInt(params?.id);
    if (isNaN(id)) return null;

    return id;
  }, [params]);

  const loadUser = useCallback(async () => {
    try {
      let res = await ax.get(`/api/users/${userId}/`);
      if (res.status === 200) {
        setUser(res.data);
      }
    } catch (e) {
      alert("You don't have rights to access this page");
    }
  }, [userId]);
  const isProviderAdmin = user?.group === roles.PROVIDER_ADMIN;

  useEffect(() => {
    if (isSelf) {
      setUser(currentUser);
    } else if (userId) {
      loadUser();
    }
  }, [loadUser, userId, currentUser, isSelf]);

  return (
    <DrawerPage px={12} py={6} width="100%">
      <Box width="100%">
        <Typography variant="h2">User Admin</Typography>

        <Box width="100%" mt={4}>
          <LabelDivider label="User Info" />
        </Box>

        <UserForm user={user} />
        {isProviderAdmin && (
          <>
            <Box width="100%" mt={4}>
              <LabelDivider label="Update Services/Areas" />
            </Box>
            <ProviderDocsForm user={user} />

            <Box width="100%" mt={4}>
              <LabelDivider label="Update Zip Codes" />
            </Box>
            <Box mb={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setLocation('/update-zip-codes')}
              >
                Update Zip Codes
              </Button>
            </Box>
          </>
        )}
        {(isSelf || user?.id === currentUser.id) && user ? (
          <Box>
            <Box width="100%" mt={4}>
              <LabelDivider label="Login Info" />
            </Box>
            <UserPasswordForm user={user} />
          </Box>
        ) : null}

        {canManageUsers ? (
          <>
            <Box width="100%" mt={4}>
              <LabelDivider label="Managed Users" />
            </Box>
            <ManagedUserForm user={user} />
          </>
        ) : null}
      </Box>
    </DrawerPage>
  );
};

export default UserFormPage;
